import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/nx.module';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { fromCamelToDash } from '../../../../../helpers/';
import { INTERCOM_COMPANY_PL } from '../../../../constants/';
import { GetCompleteAction } from '../../../../ngrx/actions/root.action';
import { AppState } from '../../../../ngrx/state';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { IntegrationNames } from '../../../core/integraition-list';
import * as integrations from '../../../core/store/integration.action';
import { removeByIdsFn } from '../../../settings/slack-alert/util/uninstall';
import * as intercomCompany from './intercom-company.actions';
import { ESIntercomCompany } from './intercom-company.actions';
import * as fromIntercomCompany from './intercom-company.reducer';

@Injectable()
export class IntercomCompanyEffects {
  private key = fromCamelToDash(INTERCOM_COMPANY_PL);

  defaultErrorHandler(action, error) {
    console.error('effect', action, error);
  }

  @Effect()
  getMany$ = this.data.fetch(intercomCompany.GET_INDEX, {
    run: (action, store) =>
      this.api.get([this.key], action.payload).pipe(
        map(jsonApiToEntityState),
        switchMap((state: ESIntercomCompany) => {
          let id;
          const actions: any[] = [
            new GetCompleteAction(state),
            new intercomCompany.GetIndexComplete(state[INTERCOM_COMPANY_PL])
          ];
          if ((id = this.getFirstId(state[INTERCOM_COMPANY_PL]))) {
            actions.push(
              new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Intercom, isInstalled: true })
            );
            actions.push(new intercomCompany.SetActive(id));
          }

          return from(actions);
        })
      ),
    onError: this.defaultErrorHandler
  });

  @Effect()
  removeAll$ = this.data.pessimisticUpdate(intercomCompany.REMOVE_ALL, {
    run: (action, store) => {
      const ids = fromIntercomCompany.getIds(store);
      return this.remover(ids).pipe(
        switchMap(_ =>
          from([
            new intercomCompany.RemoveAllComplete(),
            new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Intercom, isInstalled: false })
          ])
        )
      );
    },
    onError: (action, error) => {
      this.defaultErrorHandler(action, error);
    }
  });

  constructor(private data: DataPersistence<AppState>, private api: AtlazApiV2Service) {}

  private remover = removeByIdsFn(this.api, this.key);

  private getFirstId(state: ESIntercomCompany) {
    return state && state.ids[0];
  }
}
